import { CdrDuration3X } from '@rei/cdr-tokens/dist/js/cdr-tokens.common';
import raf from 'raf';
import onTransitionEnd from '../common/onTransitionEnd';

const animationDuration = parseInt(CdrDuration3X.replace('ms', ''), 10);

export default {
  props: {
    length: {
      type: Number,
      default: 0,
    },
    showMoreStartIx: {
      type: Number,
      default: 8,
    },
    showMoreText: {
      type: String,
      default: null,
    },
    showLessText: {
      type: String,
      default: null,
    },
    replacePattern: {
      type: String,
      // eslint-disable-next-line no-template-curly-in-string
      default: '${x}',
    },
    showMoreBtnToggle: {
      type: Function,
      default: () => {},
    },
    moreShown: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    /**
     * Used to remove transition listener and clean the timeout
     */
    unsubscribe: null,
    /**
     * Flag to know when the items are being toggled and plce the hidden rule
     * once the animation ends
     */
    collapsing: false,
    /**
     * Parent element height to be set while the elements are being toggled
     */
    height: null,
    /**
     * Use to hide the parent overflow content while the animation is taking place
     */
    overflow: null,
  }),
  computed: {
    showMore() {
      const { length, showMoreText, showLessText, replacePattern, moreShown } = this;

      let content = showMoreText || 'Show more sessions';
      if (moreShown) {
        content = showLessText || 'Show less sessions';
      }

      return content.replace(replacePattern, `(${length})`);
    },
  },
  methods: {
    /**
     * Handles the reference names on the first element to hide
     * and the last elemement hidden. Those references are used
     * to handle the toggle animation setting the parent element height
     */
    ref(ix, length) {
      const { showMoreStartIx } = this;

      let ref;
      if (ix === length - 1) {
        ref = 'lastIx';
      } else if (ix === showMoreStartIx) {
        ref = 'startIx';
      }

      return ref;
    },
    showMoreClasses(ix) {
      const { showMoreStartIx, moreShown, collapsing } = this;
      const hidden = ix >= showMoreStartIx && !moreShown && !collapsing;

      return [hidden && 'show-more__item--hidden'];
    },
    /**
     * Setups the height on the parent element to displays the animation when
     * toggling the hidden elements
     */
    toggleShowMore() {
      const { showMoreBtnToggle, moreShown, $refs } = this;

      showMoreBtnToggle(moreShown);
      if (this.unsubscribe) {
        this.unsubscribe();
      }
      this.collapsing = true;

      const { parentEl, startIx, lastIx } = $refs;

      // Calculate the current parent element height. Required for the transition animation
      this.height = `${parentEl.offsetHeight}px`;
      this.overflow = 'hidden';

      this.$nextTick(() => {
        const handle = raf(() => {
          const { offsetTop, offsetHeight } =
            !this.moreShown && startIx[0] ? startIx[0] : lastIx[0];

          this.unsubscribe = onTransitionEnd(
            parentEl,
            () => {
              this.unsubscribe();
              this.collapsing = false;
              this.unsubscribe = null;
              // Removes the parent element height to be handled by css
              this.$nextTick(() => {
                this.height = '';
                this.overflow = '';
              });
            },
            animationDuration,
          );

          // Calculate the new height so the animation starts
          const showMoreHeight = `${offsetTop + offsetHeight}px`;
          this.height = showMoreHeight;
        });
        this.unsubscribe = () => raf.cancel(handle);
      });
    },
  },
};
